/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';

import { DeclarationDialog } from '../Dialog';
import { useFormikContext } from 'formik';
import NavigationPrompt from 'react-router-navigation-prompt';
import confirmNavigationSrc from 'assets/icons/confirmNavigation.svg';
import { StyledIcon } from './styles';

export const NavigationCheckDialog = (): JSX.Element => {
  const { t } = useTranslation();
  const { dirty } = useFormikContext();

  return (
    <NavigationPrompt when={dirty}>
      {({ onConfirm, onCancel }) => (
        <DeclarationDialog
          isOpen
          isClosable
          adornment={<StyledIcon src={confirmNavigationSrc} alt="icon" />}
          onCancel={onCancel}
          onConfirm={onConfirm}
          title={t('challenges.declaration.confirmNavigation.title')}
          explanation={t(
            'challenges.declaration.confirmNavigation.explanation',
          )}
          cancelLabel={t('challenges.declaration.confirmNavigation.cancel')}
          confirmLabel={t('challenges.declaration.confirmNavigation.confirm')}
        />
      )}
    </NavigationPrompt>
  );
};
